export interface BasePetition {
  text: string;
  category: string | null;
  beginDate: string | null;
  endDate: string | null;
  isAnnual: boolean;
}

export const NULL_BASE_PETITION: BasePetition = {
  text: 'Undefined',
  category: null,
  beginDate: null,
  endDate: null,
  isAnnual: false,
};

export interface Petition extends BasePetition {
  _id: string;
}

/** Dummy petition object. */
export const NULL_PETITION: Petition = {
  _id: 'undefined',
  ...NULL_BASE_PETITION,
};

export const PetitionState = ['pending', 'active', 'lapsed'];
export type PetitionState = (typeof PetitionState)[number];

export function isPetitionState(
  value: string | undefined,
): value is PetitionState {
  return (
    value !== undefined &&
    PetitionState.indexOf(value as unknown as PetitionState) !== -1
  );
}
